import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PropertyValue = _resolveComponent("PropertyValue")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.model.outputType == 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_component_PropertyValue, {
            property: {numberValue: _ctx.numberValue, dataType: 3 },
            currency: _ctx.model.currency,
            onlyCurrentValue: true
          }, null, 8, ["property", "currency"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.model.outputType == 2)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_PropertyValue, {
            property: {numberValue: _ctx.numberValue, dataType: 1, roundingDigits: 0 },
            onlyCurrentValue: true
          }, null, 8, ["property"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.model.outputType == 3)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createVNode(_component_PropertyValue, {
            property: {numberValue: _ctx.numberValue, dataType: 3 },
            currency: _ctx.model.currency,
            onlyCurrentValue: true
          }, null, 8, ["property", "currency"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.model.outputType == 4)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createVNode(_component_PropertyValue, {
            property: {numberValue: _ctx.numberValue, dataType: 3, roundingDigits: 0 },
            onlyCurrentValue: true
          }, null, 8, ["property"])
        ]))
      : _createCommentVNode("", true)
  ]))
}